import BaseModel from '../base/BaseModel.model';
import AnnoucementResearchArea from './annoucementResearchArea.model';
import TipoEvaluacion from '../evaluacion/tipoEvaluacion.model';
import AnnoucementEvaluationType from './annoucementEvaluationType.Model';
export default class Annoucement extends BaseModel {

    public title?: string;
    public annoucementTypeId?: number;
    public description?: string;
    public termCondictionId?: number;
    public tileName?: string;
    public isRequiredCNI:boolean | null;
    public descriptionName?: string;
    public dateOpen?: Date | any;
    public dateEnd?: Date | any;
    public periodId?: number;
    public startPeriodId?: number;
    public endPeriodId?: number;
    public periodName?: string;
    public isHistoryArea:boolean | null;
    public isNationalInterest:boolean | null;
    public code?: string;
    public annoucementAreas: Array<AnnoucementResearchArea> = [];
    public tiposEvaluaciones: Array<TipoEvaluacion> = [];
    public annoucementEvaluationsTypes: Array<AnnoucementEvaluationType> = [];
    public maximumHourWorked?:number;
    constructor() {
        super();
        this.init();
    }

    init() {
        this.periodName = "";
        this.isNationalInterest = null;
        this.isRequiredCNI = null;
        this.annoucementTypeId = undefined;
        this.periodId = undefined;
        this.startPeriodId = undefined;
        this.isHistoryArea = null;
        this.endPeriodId = undefined;
        this.title = "";
        this.maximumHourWorked = null;
        this.description = "";
        this.TileName = "";
        this.descriptionName = "";
        this.termCondictionId = undefined;
        this.code = "";

    }
}